import type { FC, ReactNode } from 'react'
import type { Faq } from '@/types'

import { Plus } from 'lucide-react'
import { cn } from '@/lib/utils'

interface FaqListProps {
    faqs: Faq[]
    className?: string
}

export const FaqList: FC<FaqListProps> = ({ faqs, className }): ReactNode => {
    return (
        <div className={cn('space-y-3', className)}>
            {faqs.map((faq, index) => (
                <details
                    key={faq.question}
                    open={index === 0}
                    className='group rounded-2xl border border-border bg-white px-5 shadow-sm transition-[border-color,box-shadow] open:border-gold/50 open:shadow-md sm:px-6'
                >
                    <summary className='flex cursor-pointer list-none items-center justify-between gap-4 py-4 text-left focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold [&::-webkit-details-marker]:hidden'>
                        <h3 className='text-base font-medium leading-snug text-plum'>
                            {faq.question}
                        </h3>

                        <span
                            aria-hidden='true'
                            className='flex size-8 shrink-0 items-center justify-center rounded-full border border-gold/40 text-gold-dark transition-transform duration-300 group-open:rotate-45'
                        >
                            <Plus className='size-4' />
                        </span>
                    </summary>

                    <p className='pb-5 text-sm leading-relaxed text-muted-foreground sm:text-base'>
                        {faq.answer}
                    </p>
                </details>
            ))}
        </div>
    )
}
